import {FAILURE, PENDING, SUCCESS, RESET} from '../../constants'
import {useReducer} from 'react'

const ActionTypes = {FAILURE, PENDING, SUCCESS}
const InitialState = {
  data: {},
  errors: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: null,
        data: action.payload.data || {},
      }
    case FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
      }
    case RESET:
      return {
        ...state,
        data: {},
        errors: null,
        isLoading: false,
      }
    default:
      return state
  }
}

const useReservationNextStepActionReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useReservationNextStepActionReducer
export {ActionTypes, InitialState, Reducer}
